var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSuccess = function SvgIconSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "r9lhjm183a",
    x2: 1,
    y1: 0.145,
    y2: 0.901,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50ffc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19b9c3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-653 -231)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff",
    transform: "translate(658 236)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r9lhjm183a)",
    d: "M23.375 3.375a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm10.24 14.471L20.76 30.76h-.01a1.737 1.737 0 0 1-1.115.529 1.683 1.683 0 0 1-1.125-.548l-5.385-5.385a.383.383 0 0 1 0-.548l1.712-1.708a.372.372 0 0 1 .538 0l4.269 4.269 11.731-11.821a.38.38 0 0 1 .269-.115.349.349 0 0 1 .269.115l1.683 1.74a.379.379 0 0 1 .019.558z",
    transform: "translate(649.625 227.625)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-success.c04c757f.svg";
export { ForwardRef as ReactComponent };